<script>
  import RotatedBanner from "./RotatedBanner.svelte";

  export let settings = {
    currency: "USD",
    background_color: "red",
    banners_text: `<div>
		<p>Hello world!</p>
		<p data-currency="cad">Hello world!</p>
	</div>`,
    rotation_interval: 5,
  };

  /*
   Example html payload:
  	<div>
		<p>Special promo, $50 off!</p>
		<p data-currency="cad">Special promo, CAD 60 off!</p>
	</div>	
  	<div>
		<p>Limited free shipping! #time(YYYY-MM-DD HH:mm)</p>		
	</div>	
  */
  function htmlToBannersText(htmlText) {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlText, "text/html");
    const bannersHtml = parsedHtml.querySelectorAll("div");

    const banners = [];

    bannersHtml.forEach((bannerEl) => {
      const textElements = bannerEl.querySelectorAll("p");
      if (textElements.length === 0) {
        return;
      }

      const result = {};
      textElements.forEach((textEl) => {
        const currency = textEl.getAttribute("data-currency");

        if (currency) {
          result[currency.toLowerCase()] = textEl.innerHTML;
        } else {
          result["usd"] = textEl.innerHTML;
        }
      });

      banners.push(result);
    });

    return banners;
  }

  const banners = htmlToBannersText(settings.banners_text);
</script>

<RotatedBanner
  layoutSettings={{
    backgroundColor: settings.background_color,
    enabled: true,
  }}
  currency={settings.currency}
  texts={banners}
  autoUpdateIntervalSeconds={settings.rotation_interval}
/>
